import React, { useEffect, useState, useMemo } from 'react';

// Fisher-Yates shuffle algorithm
const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

const Slideshow = ({ images, className = '' }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  // Randomize images once on mount
  const shuffledImages = useMemo(() => {
    if (!images || images.length === 0) return [];
    return shuffleArray(images);
  }, [images]);

  useEffect(() => {
    if (!shuffledImages || shuffledImages.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % shuffledImages.length);
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, [shuffledImages]);

  if (!shuffledImages || shuffledImages.length === 0) {
    return null;
  }

  return (
    <div className={`fixed inset-0 overflow-hidden ${className}`} style={{ zIndex: 0 }}>
      <div className="relative w-full h-full">
        {shuffledImages.map((img, index) => {
          // Calculate position for slide effect
          let translateX = '0%';
          if (index === currentIndex) {
            translateX = '0%'; // Current image in view
          } else if (index === (currentIndex - 1 + shuffledImages.length) % shuffledImages.length) {
            translateX = '-100%'; // Previous image (sliding out left)
          } else {
            translateX = '100%'; // Next images (off screen right)
          }

          return (
            <div
              key={index}
              className="absolute inset-0 transition-transform duration-1000 ease-in-out"
              style={{
                transform: `translateX(${translateX})`,
                zIndex: index === currentIndex ? 1 : 0,
              }}
            >
              <img
                src={img}
                alt={`Slideshow ${index + 1}`}
                className="w-full h-full"
                style={{
                  objectFit: 'cover',
                  objectPosition: 'center center',
                }}
              />
            </div>
          );
        })}
      </div>
      {/* Dark overlay for readability */}
      <div className="absolute inset-0 bg-black opacity-60" style={{ zIndex: 2 }} />
    </div>
  );
};

export default Slideshow;
